module.exports = {
          srcSet: __webpack_public_path__ + "336a3a48e1aff9fd2312ef14ccc41494-180.png"+" 180w",
          images:[ {path: __webpack_public_path__ + "336a3a48e1aff9fd2312ef14ccc41494-180.png",width: 180,height: 216}],
          src: __webpack_public_path__ + "336a3a48e1aff9fd2312ef14ccc41494-180.png",
          toString:function(){return __webpack_public_path__ + "336a3a48e1aff9fd2312ef14ccc41494-180.png"},
          
          width: 180,
          height: 216
        }